<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="subscribers"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :loading="loading"
      hide-default-footer
      no-data-text="Нет зарегестрированных абонентов"
      loading-text="Загрузка списка абонентов"
      style="border-bottom: 1px solid #e0e0e0;"
    >
      <template v-slot:item="{ item, index }">
        <tr style="height: 60px;">
          <td>{{ index + 1 }}</td>
          <td class="py-2">
            <div>{{ item.organizationInn }}</div>
            <div class="cell-text">{{ item.organizationName }}</div>
          </td>
          <td class="py-2">
            <div>{{ item.personalInn }}</div>
            <div class="cell-text">{{ item.fullName }}</div>
          </td>
          <td class="text-center">
            <span
              v-if="(item.paid && userRole === 'registrar') || (item.paid && userRole === 'super_admin')"
              class="paid-text"
            >
              <v-icon small color="green" class="font-weight-bold">check</v-icon>
              Оплачено
            </span>
            <span v-if="!item.paid && userRole !== 'super_admin'" class="unpaid-text">
              <v-icon small color="red" class="font-weight-bold">close</v-icon>
              Неоплачено
            </span>
            <v-btn
              v-if="!item.paid && userRole === 'super_admin'"
              icon
              color="primary"
              @click.prevent="openPickDatesModal(item)"
            >
              <v-icon>monetization_on</v-icon>
            </v-btn>
          </td>
          <td class="cell-text">{{ moment.unix(item.issuedAt).format('LL') }}</td>
          <td>
            <a :href="generatePdf(item.id, 'deal')" target="_blank" rel="nofollow noreferrer noopener" class="link">
              Соглашение
            </a>
          </td>
          <td>
            <a :href="generatePdf(item.id, 'invoice')" target="_blank" rel="nofollow noreferrer noopener" class="link">
              Счет
            </a>
          </td>
          <td>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon color="#333">more_vert</v-icon>
                </v-btn>
              </template>
              <v-list class="elevation-5 menu">
                <v-list-item v-for="(el, index) in menu" :key="index">
                  <v-list-item-title style="cursor: pointer;" @click="openModalHandler(el.key, item)">
                    {{ el.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-row no-gutters justify="end" align="center" class="footer py-3 px-10">
      <div class="cell-text">
        Всего пользователей: <strong>{{ total }}</strong>
      </div>
    </v-row>
    <div class="text-center pb-6 pt-4">
      <v-pagination v-model="page" :length="countPages" total-visible="13" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DataTable',
  props: {
    subscribers: {
      type: Array,
      default: () => []
    },
    userRole: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    headers: [
      { text: '№', sortable: false },
      { text: 'Организация', align: 'left', value: 'organizationName', sortable: false },
      { text: 'Сотрудник', align: 'left', value: 'fullName', sortable: false },
      { text: 'Оплата', align: 'center', value: 'paid', sortable: false },
      { text: 'Дата', align: 'left', value: 'issuedAt', sortable: false },
      { text: '', align: 'left', sortable: false },
      { text: '', align: 'left', sortable: false },
      { text: '', sortable: false }
    ],
    // page: 1,
    itemsPerPage: 10,
    menu: [
      { title: 'Просмотр', key: 'watch' },
      // { title: 'Повысить', key: 'increase' },
      { title: 'Приостановить', key: 'pause' }
      // { title: 'Отозвать', key: 'stop' }
    ]
  }),
  watch: {
    page(val) {
      this.$store.dispatch(
        'GET_SUBSCRIBERS_LIST',
        this.searchValue
          ? { innFilter: this.searchValue, nameFilter: this.searchValue, amount: this.itemsPerPage, page: val }
          : { amount: this.itemsPerPage, page: val }
      )
    }
  },
  computed: {
    ...mapState({
      total: state => state.subscribers.total,
      loading: state => state.subscribers.loading.getSubscribers,
      searchValue: state => state.subscribers.searchValue
    }),
    countPages() {
      return Math.ceil(this.total / this.itemsPerPage)
    },
    page: {
      get() {
        return this.$store.state.subscribers.page
      },
      set(val) {
        this.$store.commit('SET_PAGE_NUMBER', val)
      }
    }
  },
  methods: {
    generatePdf(id, type) {
      const token = sessionStorage.getItem('token')
      if (type === 'deal') {
        return `http://cert.onoi.kg/api/registration/certificate-deal-pdf/${id}?token=${token}`
      } else {
        return `http://cert.onoi.kg/api/registration/certificate-invoice-pdf/${id}?token=${token}`
      }
    },
    openModalHandler(key, item) {
      this.$emit('open-modal', key, item)
    },
    openPickDatesModal(item) {
      this.$emit('open-pick-dates-modal', item)
    }
  }
}
</script>

<style lang="scss" scoped>
tbody td {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #333;
}
.cell-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #333;
}
.link {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  text-decoration-line: underline;
  color: #007aff;
}
.paid-text {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #00b61d;
}
.unpaid-text {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: red;
}
.menu {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #000000;
  width: 160px;
  border-radius: 8px;
}
.footer {
  background: #eff5fe;
  border-bottom: 1px solid #e0e0e0;
}
</style>
